import router from '../store/router/config/router'

// Maps 2 way properties to segments of the url/route path
// Will only work if these are named params specified in the\
// routes list, ie: "/account/:param/tasks" where :param is
// the matched parameter
export const mapParams = (url_param_name) => {
    const computeds = {}
    var params = {}
    if (Array.isArray(url_param_name)) {
        url_param_name.forEach((q) => {
            if (typeof q !== 'string') {
                throw 'mapParams must receive an object, array of strings or a single string'
            }
            params[q] = q
        })
    } else if (typeof url_param_name === 'object') {
        params = url_param_name
    } else if (typeof url_param_name === 'string') {
        params[url_param_name] = url_param_name
    } else {
        throw 'mapParams must receive an object, array of strings or a single string'
    }

    Object.keys(params).forEach((prop_name) => {
        var param_name = params[prop_name]
        computeds[prop_name] = {
            get: () => {
                return router.app.$route.params[param_name]
            },
            set: (param_value) => {
                // prevent redundant navigations
                if (router.app.$route.params[param_name] == param_value) {
                    // debugger
                    return
                }

                var newRoute = {
                    ...router.app.$route,
                    path: null,
                    fullPath: null
                }

                newRoute.params[param_name] = param_value

                router.replace(newRoute).catch((err) => {
                    console.error(err)
                })
            }
        }
    })
    return computeds
}

// Maps 2 way properties to query paramaters on the current url
// can be mapped to array values which will result in comma
// delimited value for the query parameter. BE AWARE: All values
// returned are in their string from. Conversion may be required!
export const mapQueries = (query_param_names) => {
    const computeds = {}
    var query_params = {}
    if (Array.isArray(query_param_names)) {
        query_param_names.forEach((q) => {
            if (typeof q !== 'string') {
                throw 'mapQueries must receive an object, array of strings or a single string'
            }
            query_params[q] = {
                name: q,
                multi: false
            }
        })
    } else if (typeof query_param_names === 'object') {
        query_params = query_param_names
    } else if (typeof query_param_names === 'string') {
        query_params[query_param_names] = {
            name: query_param_names,
            multi: false
        }
    } else {
        throw 'mapQueries must receive an object, array of strings or a single string'
    }

    Object.keys(query_params).forEach((prop_name) => {
        var param = query_params[prop_name]
        var query = param.name
        var multi = param.multi || false

        if (typeof param === 'string') {
            query = param
        }
        computeds[prop_name] = {
            get: () => {
                var query_value = router.app.$route.query[query]
                if (query_value) {
                    if (multi) {
                        return query_value.split(',').map((v) => decodeURIComponent(v))
                    } else {
                        return decodeURIComponent(query_value)
                    }
                }

                if (multi) {
                    return []
                } else {
                    return null
                }
            },
            set: (value) => {
                var currentParams = Object.assign({}, router.app.$route.query)
                if (!value) {
                    delete currentParams[query]
                } else {
                    var newParams = value
                    if (multi) {
                        if (!Array.isArray(value)) {
                            throw 'Query was flagged as multi but not setting with an array'
                        }
                        newParams = value.map((v) => encodeURIComponent(v)).join(',')
                    } else {
                        newParams = encodeURIComponent(value)
                    }
                    currentParams[query] = newParams
                }

                var newRoute = {
                    query: currentParams
                }

                router.replace(newRoute).catch((err) => {
                    console.error(err)
                })
            }
        }
    })

    return computeds
}
